import { useState } from 'react';
import { format, isToday as isTodayFNS } from 'date-fns';
import * as R from 'ramda';

import CreateWorkModal from '@atom/components/common/createWorkModals/CreateWorkModal';
import { usePreferences } from '@atom/hooks/usePreferences';
import { Icon, Tooltip } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

interface Props {
  dayDate: Date;
  firstCell?: boolean;
}

const weekColWidth = 100 / 7;

const styles = {
  dayHeaderFirst: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: fonts.sm,
    height: '60px',
    justifyContent: 'space-between',
    padding: '0.5rem',
    flex: 1,
    width: `${weekColWidth}%`,
    alignItems: 'center',
  },
  selectedDay: {
    background: colors.brand.blue,
    height: '1rem',
    width: '1rem',
    borderRadius: '0.5rem',
    color: colors.neutral.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: fonts.xs,
    fontWeight: 500,
  },
};
const isToday = (weekDate: Date) => isTodayFNS(weekDate);

const WeekViewHeaderCell = ({ dayDate, firstCell }: Props) => {
  const preferences = usePreferences();
  const requireWorkType = R.pathOr(
    false,
    ['workOrders', 'requireWorkType'],
    preferences,
  );

  const [hovering, setHovering] = useState(false);
  const [workModalOpen, setWorkModalOpen] = useState(false);

  const dayHeaderStyle = firstCell
    ? styles.dayHeaderFirst
    : {
        ...styles.dayHeaderFirst,
        borderLeft: `1px solid ${colors.neutral.ash}`,
      };

  const displayDay = (weekDate: Date) =>
    isToday(weekDate) ? (
      <div style={styles.selectedDay}>{format(weekDate, 'd')}</div>
    ) : (
      <div>{format(weekDate, 'd')}</div>
    );

  const iconStyle = {
    display: hovering ? 'block' : 'none',
    cursor: 'pointer',
  };

  const handleCreateWorkFromDay = () => {
    setWorkModalOpen(true);
  };

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      style={dayHeaderStyle}
    >
      <div>
        <div>{format(dayDate, 'eee').toUpperCase()}</div>
        {displayDay(dayDate)}
      </div>
      <Tooltip title="Create Work" placement="top">
        <div onClick={handleCreateWorkFromDay} style={iconStyle}>
          <Icon>add</Icon>
        </div>
      </Tooltip>
      <CreateWorkModal
        fromCalendarDate={dayDate}
        open={workModalOpen}
        onClose={() => setWorkModalOpen(false)}
        workTemplateRequired={requireWorkType}
        redirectOnCreate
      />
    </div>
  );
};

export default WeekViewHeaderCell;
